import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable/dist';
import * as VueCompositionApi from '@vue/composition-api';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
};

export enum AdditionItemType {
  /** 日付入力 */
  TypeDate = 'type_date',
  /** 複数選択リスト */
  TypeListMulti = 'type_list_multi',
  /** 単一選択リスト */
  TypeListSingle = 'type_list_single',
  /** テキスト入力 */
  TypeText = 'type_text'
}

export type Career = {
  __typename?: 'Career';
  /** 企業名 */
  corporationName: Scalars['String'];
  /** 仕事内容 */
  description?: Maybe<Scalars['String']>;
  /** 雇用形態名 */
  employment?: Maybe<Scalars['String']>;
  /** 雇用形態 */
  employmentType?: Maybe<CareerEmploymentType>;
  /** 入社月 */
  enrollmentMonth?: Maybe<Scalars['Int']>;
  /** 入社年 */
  enrollmentYear?: Maybe<Scalars['Int']>;
  /** 勤続年数 */
  lengthOfService?: Maybe<Scalars['Int']>;
  /** 職種名 */
  occupation?: Maybe<Scalars['String']>;
  /** 退職月 */
  retirementMonth?: Maybe<Scalars['Int']>;
  /** 退職年 */
  retirementYear?: Maybe<Scalars['Int']>;
};

export enum CareerEmploymentType {
  /** 契約社員 */
  Contract = 'contract',
  /** インターン */
  Internship = 'internship',
  /** パート・アルバイト */
  PartTime = 'part_time',
  /** 正社員 */
  Regular = 'regular',
  /** 派遣社員 */
  Temporary = 'temporary'
}

export enum CompanyVisitEntry {
  /** 事前申請 */
  AdvanceApplication = 'advance_application',
  /** 自由応募 */
  FreeApplication = 'free_application'
}

export type Credential = {
  __typename?: 'Credential';
  accessToken: Scalars['String'];
  client: Scalars['String'];
  expiry: Scalars['Int'];
  redirectToken?: Maybe<Scalars['String']>;
  redirectType?: Maybe<Scalars['String']>;
  tokenType: Scalars['String'];
  uid: Scalars['String'];
};

export type CredentialsInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  expiry?: InputMaybe<Scalars['Int']>;
  tokenType?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};

export enum GraduationStatus {
  /** 中退 */
  DropOut = 'drop_out',
  /** 卒業 */
  Graduation = 'graduation'
}

export type JobHuntingStatus = {
  __typename?: 'JobHuntingStatus';
  id: Scalars['Int'];
  label: Scalars['String'];
  value: Scalars['Int'];
};

export type License = {
  __typename?: 'License';
  /** 登録日時 */
  createdAt: Scalars['ISO8601Date'];
  /** ID */
  id: Scalars['Int'];
  /** 取得月 */
  month?: Maybe<Scalars['Int']>;
  /** 取得状況 */
  status?: Maybe<LicenseStatus>;
  /** 主な免許・資格名 */
  title: Scalars['String'];
  /** 更新日時 */
  updatedAt: Scalars['ISO8601Date'];
  /** 取得年 */
  year?: Maybe<Scalars['Int']>;
};

export enum LicenseStatus {
  /** 取得済み */
  Certified = 'certified',
  /** 取得見込み */
  Expected = 'expected'
}

export type Mutation = {
  __typename?: 'Mutation';
  proxyLogin?: Maybe<ProxySignInUserPayload>;
  signUp?: Maybe<SignUpUserPayload>;
  signUpWithFirebase?: Maybe<SignUpUserWithFirebasePayload>;
  userLogin?: Maybe<SignInUserPayload>;
  userLoginWithCredentials?: Maybe<SignInUserWithCredentialsPayload>;
  userLoginWithFirebase?: Maybe<SignInUserWithFirebasePayload>;
  userLogout?: Maybe<SignOutUserPayload>;
  userPasswordReset?: Maybe<PasswordResetPayload>;
  userResendConfirmation?: Maybe<ResendConfirmationPayload>;
  userSendPasswordReset?: Maybe<SendPasswordResetPayload>;
  userSignUp?: Maybe<UserSignUpPayload>;
  userUpdatePassword?: Maybe<UserUpdatePasswordPayload>;
};


export type MutationProxyLoginArgs = {
  fingerprint: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSignUpArgs = {
  confirmSuccessUrl?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  passwordConfirmation?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['Int']>;
};


export type MutationSignUpWithFirebaseArgs = {
  confirmSuccessUrl?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  idToken: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  passwordConfirmation?: InputMaybe<Scalars['String']>;
  provider: SocialProvider;
};


export type MutationUserLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUserLoginWithCredentialsArgs = {
  credentials: CredentialsInput;
};


export type MutationUserLoginWithFirebaseArgs = {
  idToken: Scalars['String'];
  provider: SocialProvider;
};


export type MutationUserPasswordResetArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  token: Scalars['String'];
};


export type MutationUserResendConfirmationArgs = {
  email: Scalars['String'];
};


export type MutationUserSendPasswordResetArgs = {
  email: Scalars['String'];
};


export type MutationUserSignUpArgs = {
  confirmSuccessUrl?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUserUpdatePasswordArgs = {
  currentPassword?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

/** Autogenerated return type of PasswordReset */
export type PasswordResetPayload = {
  __typename?: 'PasswordResetPayload';
  message?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of ProxySignInUser */
export type ProxySignInUserPayload = {
  __typename?: 'ProxySignInUserPayload';
  credentials: Credential;
  proxyUser?: Maybe<User>;
  user: User;
};

export type Query = {
  __typename?: 'Query';
  userCheckPasswordToken?: Maybe<User>;
  userConfirmAccount?: Maybe<User>;
};


export type QueryUserCheckPasswordTokenArgs = {
  redirectUrl?: InputMaybe<Scalars['String']>;
  resetPasswordToken: Scalars['String'];
};


export type QueryUserConfirmAccountArgs = {
  confirmationToken: Scalars['String'];
  redirectUrl: Scalars['String'];
};

/** Autogenerated return type of ResendConfirmation */
export type ResendConfirmationPayload = {
  __typename?: 'ResendConfirmationPayload';
  message: Scalars['String'];
  result: Scalars['Boolean'];
};

export type School = {
  __typename?: 'School';
  activityAdditions?: Maybe<Array<SchoolActivityAddition>>;
  activityStatuses?: Maybe<Array<SchoolActivityStatus>>;
  /** 業務委託の受付状態 */
  allowOutsourcing?: Maybe<Scalars['Boolean']>;
  allowPartTime?: Maybe<Scalars['Boolean']>;
  /** 企業訪問の応募設定 */
  companyVisitEntryType?: Maybe<CompanyVisitEntry>;
  courses?: Maybe<Array<SchoolCourse>>;
  groupName?: Maybe<Scalars['String']>;
  groupSchools?: Maybe<Array<School>>;
  id: Scalars['Int'];
  isBasicPlanOrMore?: Maybe<Scalars['Boolean']>;
  jobHuntingStatuses?: Maybe<Array<JobHuntingStatus>>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  official?: Maybe<Scalars['Boolean']>;
  plan?: Maybe<SchoolPlan>;
  schoolNumber?: Maybe<Scalars['String']>;
  schoolType?: Maybe<SchoolType>;
  teachers?: Maybe<Array<SchoolTeacher>>;
  useCertificate?: Maybe<Scalars['Boolean']>;
};

export type SchoolActivityAddition = {
  __typename?: 'SchoolActivityAddition';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  itemType: AdditionItemType;
  items?: Maybe<Array<SchoolActivityAdditionItem>>;
  maxLength?: Maybe<Scalars['Int']>;
  require: Scalars['Boolean'];
  title: Scalars['String'];
  useTime?: Maybe<Scalars['Boolean']>;
};

export type SchoolActivityAdditionItem = {
  __typename?: 'SchoolActivityAdditionItem';
  id: Scalars['Int'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SchoolActivityStatus = {
  __typename?: 'SchoolActivityStatus';
  defaultValue?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SchoolBackground = {
  __typename?: 'SchoolBackground';
  /** 学科・コース名 */
  courseName?: Maybe<Scalars['String']>;
  /** 入学月 */
  enrollmentMonth?: Maybe<Scalars['Int']>;
  /** 入学年 */
  enrollmentYear?: Maybe<Scalars['Int']>;
  /** 卒業月 */
  graduationMonth?: Maybe<Scalars['Int']>;
  /** 卒業ステータス */
  graduationStatus?: Maybe<GraduationStatus>;
  /** 卒業年 */
  graduationYear?: Maybe<Scalars['Int']>;
  /** ID */
  id: Scalars['Int'];
  /** 学校ID */
  schoolId?: Maybe<Scalars['Int']>;
  /** 学校名 */
  schoolName?: Maybe<Scalars['String']>;
  /** 学校タイプ */
  schoolType?: Maybe<SchoolType>;
};

export type SchoolCourse = {
  __typename?: 'SchoolCourse';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum SchoolPlan {
  /** ベーシックプラン */
  Basic = 'basic',
  /** マスタープラン */
  Master = 'master',
  /** プラン未登録 */
  None = 'none',
  /** スタートプラン */
  Start = 'start'
}

export type SchoolTeacher = {
  __typename?: 'SchoolTeacher';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum SchoolType {
  /** 大学 */
  College = 'college',
  /** 大学院 */
  GraduateSchool = 'graduate_school',
  /** 高等学校・高等専修学校 */
  HighSchool = 'high_school',
  /** 短期大学 */
  JuniorCollege = 'junior_college',
  /** その他の学校（海外含む） */
  Other = 'other',
  /** 特別支援学校 */
  SpecialSupportSchool = 'special_support_school',
  /** - */
  Undefined = 'undefined',
  /** 専門学校・高等専門学校 */
  VocationalSchool = 'vocational_school'
}

/** Autogenerated return type of SendPasswordReset */
export type SendPasswordResetPayload = {
  __typename?: 'SendPasswordResetPayload';
  message?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
  sendConfirmation?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of SignInUser */
export type SignInUserPayload = {
  __typename?: 'SignInUserPayload';
  credentials: Credential;
};

/** Autogenerated return type of SignInUserWithCredentials */
export type SignInUserWithCredentialsPayload = {
  __typename?: 'SignInUserWithCredentialsPayload';
  user: User;
};

/** Autogenerated return type of SignInUserWithFirebase */
export type SignInUserWithFirebasePayload = {
  __typename?: 'SignInUserWithFirebasePayload';
  credentials?: Maybe<Credential>;
  error?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of SignOutUser */
export type SignOutUserPayload = {
  __typename?: 'SignOutUserPayload';
  authenticatable: User;
};

/** Autogenerated return type of SignUpUser */
export type SignUpUserPayload = {
  __typename?: 'SignUpUserPayload';
  error?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** Autogenerated return type of SignUpUserWithFirebase */
export type SignUpUserWithFirebasePayload = {
  __typename?: 'SignUpUserWithFirebasePayload';
  error?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export enum SocialProvider {
  /** Apple */
  Apple = 'apple',
  /** Google */
  Google = 'google',
  /** Microsoft */
  Microsoft = 'microsoft'
}

export type User = {
  __typename?: 'User';
  /** 志望条件 */
  condition: UserCondition;
  /** メールアドレス */
  email: Scalars['String'];
  /** メール通知 */
  emailNotification: Scalars['Boolean'];
  /** ID */
  id: Scalars['Int'];
  /** 就活状況ステータス */
  jobHuntingStatus: Scalars['Int'];
  /** 就活状況ステータスラベル */
  jobHuntingStatusLabel: Scalars['String'];
  /** プロフィール */
  profile: UserProfile;
  /** プッシュ通知 */
  pushNotification: Scalars['Boolean'];
  /** 学校 */
  school: School;
};

export type UserCondition = {
  __typename?: 'UserCondition';
  category1?: Maybe<Scalars['String']>;
  category1Code?: Maybe<Scalars['String']>;
  category2?: Maybe<Scalars['String']>;
  category2Code?: Maybe<Scalars['String']>;
  category3?: Maybe<Scalars['String']>;
  category3Code?: Maybe<Scalars['String']>;
  corporationType1?: Maybe<Scalars['String']>;
  corporationType1Code?: Maybe<Scalars['String']>;
  corporationType2?: Maybe<Scalars['String']>;
  corporationType2Code?: Maybe<Scalars['String']>;
  corporationType3?: Maybe<Scalars['String']>;
  corporationType3Code?: Maybe<Scalars['String']>;
  holiday0?: Maybe<Scalars['Boolean']>;
  holiday1?: Maybe<Scalars['Boolean']>;
  holiday2?: Maybe<Scalars['Boolean']>;
  holiday3?: Maybe<Scalars['Boolean']>;
  holiday4?: Maybe<Scalars['Boolean']>;
  holiday5?: Maybe<Scalars['Boolean']>;
  holiday6?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  industry1?: Maybe<Scalars['String']>;
  industry1Code?: Maybe<Scalars['String']>;
  industry2?: Maybe<Scalars['String']>;
  industry2Code?: Maybe<Scalars['String']>;
  industry3?: Maybe<Scalars['String']>;
  industry3Code?: Maybe<Scalars['String']>;
  jobFeature1?: Maybe<Scalars['String']>;
  jobFeature1Code?: Maybe<Scalars['String']>;
  jobFeature2?: Maybe<Scalars['String']>;
  jobFeature2Code?: Maybe<Scalars['String']>;
  jobFeature3?: Maybe<Scalars['String']>;
  jobFeature3Code?: Maybe<Scalars['String']>;
  location1?: Maybe<Scalars['String']>;
  location1Code?: Maybe<Scalars['String']>;
  location2?: Maybe<Scalars['String']>;
  location2Code?: Maybe<Scalars['String']>;
  location3?: Maybe<Scalars['String']>;
  location3Code?: Maybe<Scalars['String']>;
  monthlyIncome?: Maybe<Scalars['Int']>;
  workEndTime?: Maybe<Scalars['ISO8601DateTime']>;
  workStartTime?: Maybe<Scalars['ISO8601DateTime']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  /** 住所ふりがな */
  addressFurigana?: Maybe<Scalars['String']>;
  /** 以降の住所 */
  addressOther?: Maybe<Scalars['String']>;
  /** アバター情報 */
  avatar?: Maybe<UserdataAvatar>;
  /** 職歴 */
  careers?: Maybe<Array<Career>>;
  /** 市区町村 */
  cityName?: Maybe<Scalars['String']>;
  /** クラス名 */
  className?: Maybe<Scalars['String']>;
  /** 学部・学科ID */
  courseId?: Maybe<Scalars['Int']>;
  /** 学部・学科名 */
  courseName?: Maybe<Scalars['String']>;
  /** 登録日時 */
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  /** 生年月日 */
  dateOfBirth?: Maybe<Scalars['ISO8601Date']>;
  /** 入学月 */
  enrollmentMonth?: Maybe<Scalars['Int']>;
  /** 入学年 */
  enrollmentYear?: Maybe<Scalars['Int']>;
  /** メイ */
  firstKana?: Maybe<Scalars['String']>;
  /** 名 */
  firstName?: Maybe<Scalars['String']>;
  /** 性別 */
  gender?: Maybe<Scalars['Int']>;
  /** 卒業月 */
  graduationMonth?: Maybe<Scalars['Int']>;
  /** 卒業状況 */
  graduationStatus?: Maybe<GraduationStatus>;
  /** 卒業年 */
  graduationYear?: Maybe<Scalars['Int']>;
  /** ID */
  id: Scalars['Int'];
  /** プロフィール画像URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** 学校承認フラグ */
  isApproved?: Maybe<Scalars['Boolean']>;
  /** 履歴書公開フラグ */
  isPublic?: Maybe<Scalars['Boolean']>;
  /** セイ */
  lastKana?: Maybe<Scalars['String']>;
  /** 姓 */
  lastName?: Maybe<Scalars['String']>;
  /** 免許・資格 */
  licenses?: Maybe<Array<License>>;
  /** 郵便番号 */
  postalCode?: Maybe<Scalars['String']>;
  /** 自己PR本文1 */
  prContent1?: Maybe<Scalars['String']>;
  /** 自己PR本文2 */
  prContent2?: Maybe<Scalars['String']>;
  /** 自己PR本文3 */
  prContent3?: Maybe<Scalars['String']>;
  /** 自己PRタイトル1 */
  prTitle1?: Maybe<Scalars['String']>;
  /** 自己PRタイトル2 */
  prTitle2?: Maybe<Scalars['String']>;
  /** 自己PRタイトル3 */
  prTitle3?: Maybe<Scalars['String']>;
  /** 都道府県名 */
  prefecture?: Maybe<Scalars['String']>;
  /** 都道府県コード */
  prefectureCode?: Maybe<Scalars['String']>;
  /** 履歴書完成率 */
  resumeRate?: Maybe<Scalars['Int']>;
  /** 学歴 */
  schoolBackgrounds?: Maybe<Array<SchoolBackground>>;
  /** 学籍番号 */
  studentNo?: Maybe<Scalars['String']>;
  /** 担任ID */
  teacherId?: Maybe<Scalars['Int']>;
  /** 担任名 */
  teacherName?: Maybe<Scalars['String']>;
  /** 電話番号 */
  tel?: Maybe<Scalars['String']>;
  /** 更新日時 */
  updatedAt?: Maybe<Scalars['ISO8601Date']>;
};

/** Autogenerated return type of UserSignUp */
export type UserSignUpPayload = {
  __typename?: 'UserSignUpPayload';
  authenticatable?: Maybe<User>;
};

/** Autogenerated return type of UserUpdatePassword */
export type UserUpdatePasswordPayload = {
  __typename?: 'UserUpdatePasswordPayload';
  authenticatable?: Maybe<User>;
};

export type UserdataAvatar = {
  __typename?: 'UserdataAvatar';
  /** アバター画像URL */
  avatarImageUrl?: Maybe<Scalars['String']>;
  /** アバター名 */
  avatarName?: Maybe<Scalars['String']>;
  /** ID */
  id: Scalars['Int'];
  /** ユーザーデータID */
  userdataId: Scalars['Int'];
};

export type ConfirmAccountQueryVariables = Exact<{
  token: Scalars['String'];
  url: Scalars['String'];
}>;


export type ConfirmAccountQuery = { __typename?: 'Query', userConfirmAccount?: { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } } | null | undefined };

export type SignInMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SignInMutation = { __typename?: 'Mutation', userLogin?: { __typename?: 'SignInUserPayload', credentials: { __typename?: 'Credential', accessToken: string, uid: string, tokenType: string, client: string, expiry: number, redirectToken?: string | null | undefined, redirectType?: string | null | undefined } } | null | undefined };

export type SignInWithFirebaseMutationVariables = Exact<{
  provider: SocialProvider;
  idToken: Scalars['String'];
}>;


export type SignInWithFirebaseMutation = { __typename?: 'Mutation', userLoginWithFirebase?: { __typename?: 'SignInUserWithFirebasePayload', url?: string | null | undefined, error?: string | null | undefined, credentials?: { __typename?: 'Credential', accessToken: string, uid: string, tokenType: string, client: string, expiry: number, redirectToken?: string | null | undefined, redirectType?: string | null | undefined } | null | undefined } | null | undefined };

export type SignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutMutation = { __typename?: 'Mutation', userLogout?: { __typename?: 'SignOutUserPayload', authenticatable: { __typename?: 'User', id: number, email: string } } | null | undefined };

export type SignUpMutationVariables = Exact<{
  email: Scalars['String'];
  schoolId?: InputMaybe<Scalars['Int']>;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp?: { __typename?: 'SignUpUserPayload', user?: { __typename?: 'User', email: string } | null | undefined } | null | undefined };

export type SignUpWithFirebaseMutationVariables = Exact<{
  provider: SocialProvider;
  idToken: Scalars['String'];
}>;


export type SignUpWithFirebaseMutation = { __typename?: 'Mutation', signUpWithFirebase?: { __typename?: 'SignUpUserWithFirebasePayload', url?: string | null | undefined, error?: string | null | undefined, user?: { __typename?: 'User', email: string } | null | undefined } | null | undefined };

export type UpdatePasswordMutationVariables = Exact<{
  currentPassword?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', userUpdatePassword?: { __typename?: 'UserUpdatePasswordPayload', authenticatable?: { __typename?: 'User', id: number, email: string } | null | undefined } | null | undefined };

export type ResendConfirmationMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResendConfirmationMutation = { __typename?: 'Mutation', userResendConfirmation?: { __typename?: 'ResendConfirmationPayload', message: string, result: boolean } | null | undefined };

export type SendPasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendPasswordResetMutation = { __typename?: 'Mutation', userSendPasswordReset?: { __typename?: 'SendPasswordResetPayload', message?: string | null | undefined, result?: boolean | null | undefined, sendConfirmation?: boolean | null | undefined } | null | undefined };

export type PasswordResetMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', userPasswordReset?: { __typename?: 'PasswordResetPayload', message?: string | null | undefined, result?: boolean | null | undefined } | null | undefined };

export type UserConditionAttributesFragment = { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined };

export type UserAttributesFragment = { __typename?: 'User', id: number, email: string, pushNotification: boolean, emailNotification: boolean, jobHuntingStatus: number, jobHuntingStatusLabel: string, school: { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined }, profile: { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined }, condition: { __typename?: 'UserCondition', id: number, industry1Code?: string | null | undefined, industry1?: string | null | undefined, industry2Code?: string | null | undefined, industry2?: string | null | undefined, industry3Code?: string | null | undefined, industry3?: string | null | undefined, category1Code?: string | null | undefined, category1?: string | null | undefined, category2Code?: string | null | undefined, category2?: string | null | undefined, category3Code?: string | null | undefined, category3?: string | null | undefined, location1Code?: string | null | undefined, location1?: string | null | undefined, location2Code?: string | null | undefined, location2?: string | null | undefined, location3Code?: string | null | undefined, location3?: string | null | undefined, corporationType1Code?: string | null | undefined, corporationType1?: string | null | undefined, corporationType2Code?: string | null | undefined, corporationType2?: string | null | undefined, corporationType3Code?: string | null | undefined, corporationType3?: string | null | undefined, jobFeature1Code?: string | null | undefined, jobFeature1?: string | null | undefined, jobFeature2Code?: string | null | undefined, jobFeature2?: string | null | undefined, jobFeature3Code?: string | null | undefined, jobFeature3?: string | null | undefined, monthlyIncome?: number | null | undefined, holiday0?: boolean | null | undefined, holiday1?: boolean | null | undefined, holiday2?: boolean | null | undefined, holiday3?: boolean | null | undefined, holiday4?: boolean | null | undefined, holiday5?: boolean | null | undefined, holiday6?: boolean | null | undefined, workStartTime?: any | null | undefined, workEndTime?: any | null | undefined } };

export type UserProfileAttributesFragment = { __typename?: 'UserProfile', id: number, firstName?: string | null | undefined, lastName?: string | null | undefined, firstKana?: string | null | undefined, lastKana?: string | null | undefined, courseId?: number | null | undefined, courseName?: string | null | undefined, className?: string | null | undefined, studentNo?: string | null | undefined, teacherId?: number | null | undefined, teacherName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined, gender?: number | null | undefined, dateOfBirth?: any | null | undefined, postalCode?: string | null | undefined, prefectureCode?: string | null | undefined, prefecture?: string | null | undefined, cityName?: string | null | undefined, addressOther?: string | null | undefined, addressFurigana?: string | null | undefined, tel?: string | null | undefined, imageUrl?: string | null | undefined, prTitle1?: string | null | undefined, prContent1?: string | null | undefined, prTitle2?: string | null | undefined, prContent2?: string | null | undefined, prTitle3?: string | null | undefined, prContent3?: string | null | undefined, resumeRate?: number | null | undefined, isApproved?: boolean | null | undefined, isPublic?: boolean | null | undefined, createdAt?: any | null | undefined, licenses?: Array<{ __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any }> | null | undefined, careers?: Array<{ __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined }> | null | undefined, schoolBackgrounds?: Array<{ __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined }> | null | undefined };

export type LicenseAttributesFragment = { __typename?: 'License', id: number, title: string, year?: number | null | undefined, month?: number | null | undefined, status?: LicenseStatus | null | undefined, createdAt: any, updatedAt: any };

export type CareerAttributesFragment = { __typename?: 'Career', corporationName: string, employment?: string | null | undefined, employmentType?: CareerEmploymentType | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, retirementYear?: number | null | undefined, retirementMonth?: number | null | undefined, lengthOfService?: number | null | undefined, occupation?: string | null | undefined, description?: string | null | undefined };

export type SchoolBackgroundAttributesFragment = { __typename?: 'SchoolBackground', id: number, schoolId?: number | null | undefined, schoolType?: SchoolType | null | undefined, schoolName?: string | null | undefined, courseName?: string | null | undefined, enrollmentYear?: number | null | undefined, enrollmentMonth?: number | null | undefined, graduationYear?: number | null | undefined, graduationMonth?: number | null | undefined, graduationStatus?: GraduationStatus | null | undefined };

export type SchoolAttributesFragment = { __typename?: 'School', id: number, name: string, plan?: SchoolPlan | null | undefined, isBasicPlanOrMore?: boolean | null | undefined, schoolNumber?: string | null | undefined, useCertificate?: boolean | null | undefined, logoUrl?: string | null | undefined, official?: boolean | null | undefined, allowPartTime?: boolean | null | undefined, allowOutsourcing?: boolean | null | undefined, companyVisitEntryType?: CompanyVisitEntry | null | undefined, groupName?: string | null | undefined, courses?: Array<{ __typename?: 'SchoolCourse', id: number, name: string }> | null | undefined, teachers?: Array<{ __typename?: 'SchoolTeacher', id: number, name: string }> | null | undefined, activityAdditions?: Array<{ __typename?: 'SchoolActivityAddition', id: number, title: string, description?: string | null | undefined, require: boolean, itemType: AdditionItemType, maxLength?: number | null | undefined, useTime?: boolean | null | undefined, items?: Array<{ __typename?: 'SchoolActivityAdditionItem', id: number, value: string, label: string }> | null | undefined }> | null | undefined, activityStatuses?: Array<{ __typename?: 'SchoolActivityStatus', value: string, label: string, defaultValue?: string | null | undefined }> | null | undefined, jobHuntingStatuses?: Array<{ __typename?: 'JobHuntingStatus', id: number, value: number, label: string }> | null | undefined, groupSchools?: Array<{ __typename?: 'School', id: number, name: string }> | null | undefined };

export const SchoolAttributesFragmentDoc = gql`
    fragment SchoolAttributes on School {
  id
  name
  plan
  isBasicPlanOrMore
  schoolNumber
  useCertificate
  logoUrl
  official
  allowPartTime
  allowOutsourcing
  companyVisitEntryType
  courses {
    id
    name
  }
  teachers {
    id
    name
  }
  activityAdditions {
    id
    title
    description
    require
    itemType
    maxLength
    useTime
    items {
      id
      value
      label
    }
  }
  activityStatuses {
    value
    label
    defaultValue
  }
  jobHuntingStatuses {
    id
    value
    label
  }
  groupName
  groupSchools {
    id
    name
  }
}
    `;
export const LicenseAttributesFragmentDoc = gql`
    fragment LicenseAttributes on License {
  id
  title
  year
  month
  status
  createdAt
  updatedAt
}
    `;
export const CareerAttributesFragmentDoc = gql`
    fragment CareerAttributes on Career {
  corporationName
  employment
  employmentType
  enrollmentYear
  enrollmentMonth
  retirementYear
  retirementMonth
  lengthOfService
  occupation
  description
}
    `;
export const SchoolBackgroundAttributesFragmentDoc = gql`
    fragment SchoolBackgroundAttributes on SchoolBackground {
  id
  schoolId
  schoolType
  schoolName
  courseName
  enrollmentYear
  enrollmentMonth
  graduationYear
  graduationMonth
  graduationStatus
}
    `;
export const UserProfileAttributesFragmentDoc = gql`
    fragment UserProfileAttributes on UserProfile {
  id
  firstName
  lastName
  firstKana
  lastKana
  courseId
  courseName
  className
  studentNo
  teacherId
  teacherName
  enrollmentYear
  enrollmentMonth
  graduationYear
  graduationMonth
  graduationStatus
  gender
  dateOfBirth
  postalCode
  prefectureCode
  prefecture
  cityName
  addressOther
  addressFurigana
  tel
  imageUrl
  prTitle1
  prContent1
  prTitle2
  prContent2
  prTitle3
  prContent3
  resumeRate
  isApproved
  isPublic
  createdAt
  licenses {
    ...LicenseAttributes
  }
  careers {
    ...CareerAttributes
  }
  schoolBackgrounds {
    ...SchoolBackgroundAttributes
  }
}
    ${LicenseAttributesFragmentDoc}
${CareerAttributesFragmentDoc}
${SchoolBackgroundAttributesFragmentDoc}`;
export const UserConditionAttributesFragmentDoc = gql`
    fragment UserConditionAttributes on UserCondition {
  id
  industry1Code
  industry1
  industry2Code
  industry2
  industry3Code
  industry3
  category1Code
  category1
  category2Code
  category2
  category3Code
  category3
  location1Code
  location1
  location2Code
  location2
  location3Code
  location3
  corporationType1Code
  corporationType1
  corporationType2Code
  corporationType2
  corporationType3Code
  corporationType3
  jobFeature1Code
  jobFeature1
  jobFeature2Code
  jobFeature2
  jobFeature3Code
  jobFeature3
  monthlyIncome
  holiday0
  holiday1
  holiday2
  holiday3
  holiday4
  holiday5
  holiday6
  workStartTime
  workEndTime
}
    `;
export const UserAttributesFragmentDoc = gql`
    fragment UserAttributes on User {
  id
  email
  pushNotification
  emailNotification
  jobHuntingStatus
  jobHuntingStatusLabel
  school {
    ...SchoolAttributes
  }
  profile {
    ...UserProfileAttributes
  }
  condition {
    ...UserConditionAttributes
  }
}
    ${SchoolAttributesFragmentDoc}
${UserProfileAttributesFragmentDoc}
${UserConditionAttributesFragmentDoc}`;
export const ConfirmAccountDocument = gql`
    query ConfirmAccount($token: String!, $url: String!) {
  userConfirmAccount(confirmationToken: $token, redirectUrl: $url) {
    ...UserAttributes
  }
}
    ${UserAttributesFragmentDoc}`;

/**
 * __useConfirmAccountQuery__
 *
 * To run a query within a Vue component, call `useConfirmAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmAccountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfirmAccountQuery({
 *   token: // value for 'token'
 *   url: // value for 'url'
 * });
 */
export function useConfirmAccountQuery(variables: ConfirmAccountQueryVariables | VueCompositionApi.Ref<ConfirmAccountQueryVariables> | ReactiveFunction<ConfirmAccountQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfirmAccountQuery, ConfirmAccountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfirmAccountQuery, ConfirmAccountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfirmAccountQuery, ConfirmAccountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfirmAccountQuery, ConfirmAccountQueryVariables>(ConfirmAccountDocument, variables, options);
}
export type ConfirmAccountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfirmAccountQuery, ConfirmAccountQueryVariables>;
export const SignInDocument = gql`
    mutation SignIn($email: String!, $password: String!) {
  userLogin(email: $email, password: $password) {
    credentials {
      accessToken
      uid
      tokenType
      client
      expiry
      redirectToken
      redirectType
    }
  }
}
    `;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignInMutation({
 *   variables: {
 *     email: // value for 'email'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(options: VueApolloComposable.UseMutationOptions<SignInMutation, SignInMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignInMutation, SignInMutationVariables>>) {
  return VueApolloComposable.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
}
export type SignInMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignInMutation, SignInMutationVariables>;
export const SignInWithFirebaseDocument = gql`
    mutation SignInWithFirebase($provider: SocialProvider!, $idToken: String!) {
  userLoginWithFirebase(provider: $provider, idToken: $idToken) {
    credentials {
      accessToken
      uid
      tokenType
      client
      expiry
      redirectToken
      redirectType
    }
    url
    error
  }
}
    `;

/**
 * __useSignInWithFirebaseMutation__
 *
 * To run a mutation, you first call `useSignInWithFirebaseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithFirebaseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignInWithFirebaseMutation({
 *   variables: {
 *     provider: // value for 'provider'
 *     idToken: // value for 'idToken'
 *   },
 * });
 */
export function useSignInWithFirebaseMutation(options: VueApolloComposable.UseMutationOptions<SignInWithFirebaseMutation, SignInWithFirebaseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignInWithFirebaseMutation, SignInWithFirebaseMutationVariables>>) {
  return VueApolloComposable.useMutation<SignInWithFirebaseMutation, SignInWithFirebaseMutationVariables>(SignInWithFirebaseDocument, options);
}
export type SignInWithFirebaseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignInWithFirebaseMutation, SignInWithFirebaseMutationVariables>;
export const SignOutDocument = gql`
    mutation SignOut {
  userLogout {
    authenticatable {
      id
      email
    }
  }
}
    `;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignOutMutation();
 */
export function useSignOutMutation(options: VueApolloComposable.UseMutationOptions<SignOutMutation, SignOutMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignOutMutation, SignOutMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SignOutMutation, SignOutMutationVariables>(SignOutDocument, options);
}
export type SignOutMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignOutMutation, SignOutMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($email: String!, $schoolId: Int) {
  signUp(email: $email, schoolId: $schoolId) {
    user {
      email
    }
  }
}
    `;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignUpMutation({
 *   variables: {
 *     email: // value for 'email'
 *     schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useSignUpMutation(options: VueApolloComposable.UseMutationOptions<SignUpMutation, SignUpMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignUpMutation, SignUpMutationVariables>>) {
  return VueApolloComposable.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
}
export type SignUpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignUpMutation, SignUpMutationVariables>;
export const SignUpWithFirebaseDocument = gql`
    mutation SignUpWithFirebase($provider: SocialProvider!, $idToken: String!) {
  signUpWithFirebase(provider: $provider, idToken: $idToken) {
    user {
      email
    }
    url
    error
  }
}
    `;

/**
 * __useSignUpWithFirebaseMutation__
 *
 * To run a mutation, you first call `useSignUpWithFirebaseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSignUpWithFirebaseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSignUpWithFirebaseMutation({
 *   variables: {
 *     provider: // value for 'provider'
 *     idToken: // value for 'idToken'
 *   },
 * });
 */
export function useSignUpWithFirebaseMutation(options: VueApolloComposable.UseMutationOptions<SignUpWithFirebaseMutation, SignUpWithFirebaseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SignUpWithFirebaseMutation, SignUpWithFirebaseMutationVariables>>) {
  return VueApolloComposable.useMutation<SignUpWithFirebaseMutation, SignUpWithFirebaseMutationVariables>(SignUpWithFirebaseDocument, options);
}
export type SignUpWithFirebaseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SignUpWithFirebaseMutation, SignUpWithFirebaseMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($currentPassword: String, $password: String!, $passwordConfirmation: String!) {
  userUpdatePassword(
    currentPassword: $currentPassword
    password: $password
    passwordConfirmation: $passwordConfirmation
  ) {
    authenticatable {
      id
      email
    }
  }
}
    `;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePasswordMutation({
 *   variables: {
 *     currentPassword: // value for 'currentPassword'
 *     password: // value for 'password'
 *     passwordConfirmation: // value for 'passwordConfirmation'
 *   },
 * });
 */
export function useUpdatePasswordMutation(options: VueApolloComposable.UseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
}
export type UpdatePasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const ResendConfirmationDocument = gql`
    mutation ResendConfirmation($email: String!) {
  userResendConfirmation(email: $email) {
    message
    result
  }
}
    `;

/**
 * __useResendConfirmationMutation__
 *
 * To run a mutation, you first call `useResendConfirmationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResendConfirmationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResendConfirmationMutation({
 *   variables: {
 *     email: // value for 'email'
 *   },
 * });
 */
export function useResendConfirmationMutation(options: VueApolloComposable.UseMutationOptions<ResendConfirmationMutation, ResendConfirmationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResendConfirmationMutation, ResendConfirmationMutationVariables>>) {
  return VueApolloComposable.useMutation<ResendConfirmationMutation, ResendConfirmationMutationVariables>(ResendConfirmationDocument, options);
}
export type ResendConfirmationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResendConfirmationMutation, ResendConfirmationMutationVariables>;
export const SendPasswordResetDocument = gql`
    mutation SendPasswordReset($email: String!) {
  userSendPasswordReset(email: $email) {
    message
    result
    sendConfirmation
  }
}
    `;

/**
 * __useSendPasswordResetMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendPasswordResetMutation({
 *   variables: {
 *     email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetMutation(options: VueApolloComposable.UseMutationOptions<SendPasswordResetMutation, SendPasswordResetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendPasswordResetMutation, SendPasswordResetMutationVariables>>) {
  return VueApolloComposable.useMutation<SendPasswordResetMutation, SendPasswordResetMutationVariables>(SendPasswordResetDocument, options);
}
export type SendPasswordResetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendPasswordResetMutation, SendPasswordResetMutationVariables>;
export const PasswordResetDocument = gql`
    mutation PasswordReset($token: String!, $password: String!, $passwordConfirmation: String!) {
  userPasswordReset(
    token: $token
    password: $password
    passwordConfirmation: $passwordConfirmation
  ) {
    message
    result
  }
}
    `;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePasswordResetMutation({
 *   variables: {
 *     token: // value for 'token'
 *     password: // value for 'password'
 *     passwordConfirmation: // value for 'passwordConfirmation'
 *   },
 * });
 */
export function usePasswordResetMutation(options: VueApolloComposable.UseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>>) {
  return VueApolloComposable.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, options);
}
export type PasswordResetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PasswordResetMutation, PasswordResetMutationVariables>;